const RESET_SHIFTS_INFO_TEXT = "Le nombre de couverts a été modifié. Vous devrez à nouveau sélectionner une date et une heure pour votre réservation.";
export const RESET_SHIFTS_INFO = RESET_SHIFTS_INFO_TEXT;

const CHECK_AVAILABILITY_FAILED_INFO_TEXT = "Cette date ou heure n'est malheureusement plus disponible. Il vous est toujours possible de choisir un autre moment :)";
export const CHECK_AVAILABILITY_FAILED_INFO = CHECK_AVAILABILITY_FAILED_INFO_TEXT;


// WEBPACK FOOTER //
// ./src/infos.js